import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Statistics from './statistics.vue'
import SendTest from './sendTest.vue'
import Send from './send.vue'
import Undo from './undo.vue'
import Redo from './redo.vue'
import Pause from './pause.vue'
import DripStatus from './dripStatus.vue'
import RSSScheduleIcon from './rssScheduled.vue'
import Mobile from './mobile.vue'
import MobileHidden from './mobileHidden.vue'
import Desktop from './desktop.vue'
import DesktopHidden from './desktopHidden.vue'
import ABTest from './ABTest.vue'
import { UIIcon } from '@gohighlevel/ghl-canvas'
import Trophy from './Trophy.vue'
import Eye from './Eye.vue'
import Click from './Click.vue'
import SquareList from './squareList.vue'
import CircleList from './circleList.vue'
import DiscList from './discList.vue'
import LowerAlphaList from './lowerAlphaList.vue'
import LowerGreek from './lowerGreek.vue'
import LowerRoman from './lowerRoman.vue'
import UpperAlpha from './upperAlpha.vue'
import UpperRoman from './upperRoman.vue'
import DecimalList from './decimalList.vue'
import Dots from './sidebar/Dots.vue'
import Text from './sidebar/Text.vue'
import ButtonIcon from './sidebar/ButtonIcon.vue'
import Social from './sidebar/Social.vue'
import Image from './sidebar/Image.vue'
import Divider from './sidebar/Divider.vue'
import FooterIcon from './sidebar/FooterIcon.vue'
import CodeIcon from './sidebar/CodeIcon.vue'
import VideoIcon from './sidebar/VideoIcon.vue'
import ShoppingCart from './sidebar/ShoppingCart.vue'
import Rss from './sidebar/Rss.vue'
import Layers from './sidebar/Layers.vue'
import Layout from './Layout.vue'
import ContentBottom from './ContentBottom.vue'
import ContentTop from './ContentTop.vue'
import ContentLeft from './ContentLeft.vue'
import ContentRight from './ContentRight.vue'
import ContentDoubleBottom from './ContentDoubleBottom.vue'
import ContentDoubleTop from './ContentDoubleTop.vue'
import LogoIcon from './sidebar/LogoIcon.vue'
import BlankDesign from './BlankDesign.vue'
import BlankCode from './BlankCode.vue'
import Faq from './sidebar/Faq.vue'
import Product from './Product.vue'
import Slider from './Slider.vue'
import PreviewUrl from './PreviewUrl.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomIcon',
  props: {
  iconName: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    required: false,
    default: '',
  },
  fillColor: {
    type: String,
    required: false,
    default: '#000',
  },
  strokeColor: {
    type: String,
    required: false,
    default: '#000',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.iconName.includes('custom'))
      ? (_openBlock(), _createBlock(_unref(UIIcon), {
          key: 0,
          icon: __props.iconName,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["icon", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:statistics')
      ? (_openBlock(), _createBlock(Statistics, {
          key: 1,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:send-test')
      ? (_openBlock(), _createBlock(SendTest, {
          key: 2,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:undo')
      ? (_openBlock(), _createBlock(Undo, {
          key: 3,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:redo')
      ? (_openBlock(), _createBlock(Redo, {
          key: 4,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:drip-status')
      ? (_openBlock(), _createBlock(DripStatus, {
          key: 5,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:filled-drip-status')
      ? (_openBlock(), _createBlock(DripStatus, {
          key: 6,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className),
          filled: true
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:send')
      ? (_openBlock(), _createBlock(Send, {
          key: 7,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:pause')
      ? (_openBlock(), _createBlock(Pause, {
          key: 8,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:rss')
      ? (_openBlock(), _createBlock(RSSScheduleIcon, {
          key: 9,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:filled:rss')
      ? (_openBlock(), _createBlock(RSSScheduleIcon, {
          key: 10,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className),
          filled: true
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:mobile')
      ? (_openBlock(), _createBlock(Mobile, {
          key: 11,
          fillColor: __props.fillColor
        }, null, 8 /* PROPS */, ["fillColor"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:mobile-hidden')
      ? (_openBlock(), _createBlock(MobileHidden, {
          key: 12,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:desktop')
      ? (_openBlock(), _createBlock(Desktop, {
          key: 13,
          fillColor: __props.fillColor
        }, null, 8 /* PROPS */, ["fillColor"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:desktop-hidden')
      ? (_openBlock(), _createBlock(DesktopHidden, {
          key: 14,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:ab-test')
      ? (_openBlock(), _createBlock(ABTest, {
          key: 15,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:trophy')
      ? (_openBlock(), _createBlock(Trophy, {
          key: 16,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:eye')
      ? (_openBlock(), _createBlock(Eye, {
          key: 17,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-icon:click')
      ? (_openBlock(), _createBlock(Click, {
          key: 18,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-square-list:click')
      ? (_openBlock(), _createBlock(SquareList, {
          key: 19,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:dots')
      ? (_openBlock(), _createBlock(Dots, {
          key: 20,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-circle-list:click')
      ? (_openBlock(), _createBlock(CircleList, {
          key: 21,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:layout')
      ? (_openBlock(), _createBlock(Layout, {
          key: 22,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:text')
      ? (_openBlock(), _createBlock(Text, {
          key: 23,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-disc-list:click')
      ? (_openBlock(), _createBlock(DiscList, {
          key: 24,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:image')
      ? (_openBlock(), _createBlock(Image, {
          key: 25,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-lower-alpha-list:click')
      ? (_openBlock(), _createBlock(LowerAlphaList, {
          key: 26,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:button')
      ? (_openBlock(), _createBlock(ButtonIcon, {
          key: 27,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:logo')
      ? (_openBlock(), _createBlock(LogoIcon, {
          key: 28,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-lower-greek-list:click')
      ? (_openBlock(), _createBlock(LowerGreek, {
          key: 29,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:divider')
      ? (_openBlock(), _createBlock(Divider, {
          key: 30,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-lower-roman-list:click')
      ? (_openBlock(), _createBlock(LowerRoman, {
          key: 31,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-upper-alpha-list:click')
      ? (_openBlock(), _createBlock(UpperAlpha, {
          key: 32,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-upper-roman-list:click')
      ? (_openBlock(), _createBlock(UpperRoman, {
          key: 33,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-decimal-list:click')
      ? (_openBlock(), _createBlock(DecimalList, {
          key: 34,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:social')
      ? (_openBlock(), _createBlock(Social, {
          key: 35,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:footer')
      ? (_openBlock(), _createBlock(FooterIcon, {
          key: 36,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:code')
      ? (_openBlock(), _createBlock(CodeIcon, {
          key: 37,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:video')
      ? (_openBlock(), _createBlock(VideoIcon, {
          key: 38,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:shopping')
      ? (_openBlock(), _createBlock(ShoppingCart, {
          key: 39,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:rss')
      ? (_openBlock(), _createBlock(Rss, {
          key: 40,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:layers')
      ? (_openBlock(), _createBlock(Layers, {
          key: 41,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-bottom')
      ? (_openBlock(), _createBlock(ContentBottom, {
          key: 42,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-top')
      ? (_openBlock(), _createBlock(ContentTop, {
          key: 43,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-left')
      ? (_openBlock(), _createBlock(ContentLeft, {
          key: 44,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-right')
      ? (_openBlock(), _createBlock(ContentRight, {
          key: 45,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-double-bottom')
      ? (_openBlock(), _createBlock(ContentDoubleBottom, {
          key: 46,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-layout-icon:content-double-top')
      ? (_openBlock(), _createBlock(ContentDoubleTop, {
          key: 47,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-blank-icon:design')
      ? (_openBlock(), _createBlock(BlankDesign, {
          key: 48,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-blank-icon:code')
      ? (_openBlock(), _createBlock(BlankCode, {
          key: 49,
          "fill-color": __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fill-color", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:faq')
      ? (_openBlock(), _createBlock(Faq, {
          key: 50,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:product')
      ? (_openBlock(), _createBlock(Product, {
          key: 51,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:image-slider')
      ? (_openBlock(), _createBlock(Slider, {
          key: 52,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true),
    (__props.iconName === 'custom-builder-sidebar-icon:preview-url')
      ? (_openBlock(), _createBlock(PreviewUrl, {
          key: 53,
          fillColor: __props.fillColor,
          strokeColor: __props.strokeColor,
          class: _normalizeClass(__props.className)
        }, null, 8 /* PROPS */, ["fillColor", "strokeColor", "class"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})